"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var clipboard = require("clipboard-polyfill");
var Notification_1 = require("../utils/Notification");
var ClipboardUtils = /** @class */ (function () {
    function ClipboardUtils() {
    }
    // Copies a string to the clipboard. Must be called from within an
    // event handler such as click.
    ClipboardUtils.copyTextToClipboard = function (text, successMessage) {
        var successCallback = function () {
            Notification_1.Notification.Instance.showInfo(successMessage);
        };
        var failureCallback = function () {
            // Do nothing for now
        };
        clipboard.writeText(text).then(successCallback, failureCallback);
    };
    return ClipboardUtils;
}());
exports.ClipboardUtils = ClipboardUtils;
//# sourceMappingURL=ClipboardUtils.js.map